import React from 'react'
import ServiceLayout from '../components/ServiceLayout'
import { useTranslation, Trans } from 'react-i18next'

const TechnicalResourcesPage = () => {
    const { t } = useTranslation()

    return (
        <ServiceLayout
            breadcrumbs={[
                { label: t('header.home'), path: '/' },
                { label: t('technicalResources.title') }
            ]}
            title={t('technicalResources.title')}
            subtitle={t('technicalResources.subtitle')}
        >
            <div className="bio-card-static rounded-xl p-8 border border-blue-200 text-center">
                <span className="material-symbols-outlined text-blue-600 text-4xl mb-4 block">library_books</span>
                <h2 className="text-xl font-bold text-blue-600 mb-2">{t('technicalResources.comingSoon.title')}</h2>
                <p className="text-blue-600/70 text-sm">
                    <Trans i18nKey="technicalResources.comingSoon.desc">
                        Technical resources, documentation, and educational materials are being prepared. Subscribe to our updates or <a href="/contact" className="font-semibold underline">contact us</a> for specific technical inquiries.
                    </Trans>
                </p>
            </div>
        </ServiceLayout>
    )
}

export default TechnicalResourcesPage
